import React from 'react'
import pt from 'prop-types'
import { get } from 'lodash-es'

import Heart from '../../icon/Activites'
import LinkWithLogin from '../../LinkWithLogin'

const Activities = ({ pathname, user, hasUnchecked }) => {
  const isActive = !!pathname.startsWith('/activities')

  return (
    <div className={'main-menu-item main-menu-item--activities ' + (isActive && 'main-menu-item--active')}>
      <LinkWithLogin to={get(user, 'data.user.username') ? `/activities` : '/profile'}>
        <Heart />
      </LinkWithLogin>
      {hasUnchecked && <div className="unchecked" />}
    </div>
  )
}

Activities.propTypes = {
  pathname: pt.string,
  user: pt.shape({}),
  hasUnchecked: pt.bool
}

export default Activities
